import * as iter from './utils/iter';

/**
 * @typedef {Readonly<{
 *   path: string,
 *   pathEn: string,
 *   pathDe: string,
 *   titleI18nId: string,
 * }>} PageMetadata
 */

/** @type {Readonly<Array<PageMetadata>>} */
export const DATA = Object.freeze(
	[
		{
			path: '/',
			pathDe: '/',
			titleI18nId: 'nav.home'
		},
		{
			path: '/map/',
			pathDe: '/karte/',
			titleI18nId: 'nav.map',
		},
		{
			path: '/blog/',
			pathDe: '/blog/',
			titleI18nId: 'nav.blog',
		},
		{
			path: '/contact/',
			pathDe: '/kontakt/',
			titleI18nId: 'nav.contact',
		},
		{
			path: '/imprint/',
			pathDe: '/impressum/',
			titleI18nId: 'nav.imprint',
		},
		{
			path: '/events/',
			pathDe: '/veranstaltungen/',
			titleI18nId: 'nav.events',
		},
		{
			path: '/tours/',
			pathDe: '/touren/',
			titleI18nId: 'nav.tours',
		},
		{
			path: '/lights-off/',
			pathDe: '/lights-off/',
			titleI18nId: 'nav.lightsOff',
		},
		{
			path: '/press/',
			pathDe: '/presse/',
			titleI18nId: 'nav.press',
		},
		{
			path: '/sponsors/',
			pathDe: '/unterstuetzer/',
			titleI18nId: 'nav.sponsors',
		},
	]
		.map((entry) => Object.freeze({
			...entry,
			pathEn: `/en${entry.path}`,
		})),
);

/** @type {Readonly<Object<string, PageMetadata>>} */
export const DATA_MAP = Object.freeze(
	Object.fromEntries(
		iter.from(DATA).map((md) => [md.path, md])
	)
);

export default DATA_MAP;
